import { AppUITheme } from 'features/website-layout/types';

export const getColor = (currentTheme: AppUITheme) => {
  const colors = {
    [AppUITheme.CHARTER_TRANSPORT]: 'lightBlue.500',
    [AppUITheme.TRANSPORT]: 'blue.500',
    [AppUITheme.LOGISTICS]: 'orange.500',
    [AppUITheme.CHARTER_LOGISTICS]: 'orange.500',
    [AppUITheme.NA]: 'orange.500',
  };
  return colors[currentTheme];
};

export const getColorScheme = (currentTheme: AppUITheme) => {
  const colors = {
    [AppUITheme.CHARTER_TRANSPORT]: 'lightBlue',
    [AppUITheme.TRANSPORT]: 'blue',
    [AppUITheme.LOGISTICS]: 'orange',
    [AppUITheme.CHARTER_LOGISTICS]: 'orange',
    [AppUITheme.NA]: 'orange',
  };
  return colors[currentTheme];
};
